import { render, staticRenderFns } from "./BookingRegistrationFormView.vue?vue&type=template&id=265fa343&scoped=true&"
import script from "./BookingRegistrationFormView.vue?vue&type=script&lang=ts&"
export * from "./BookingRegistrationFormView.vue?vue&type=script&lang=ts&"
import style0 from "./BookingRegistrationFormView.vue?vue&type=style&index=0&id=265fa343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265fa343",
  null
  
)

export default component.exports